export const items = [
	{
		id: 'nav-item-funcionalidades',
		type: 'anchor',
		title: 'Funcionalidades',
		link: 'funcionalidades',
		showOn: ['themisEA', 'themisDJ', 'subPage'],
	},
	{
		id: 'nav-item-funcionalidades',
		type: 'sublist',
		title: 'Funcionalidades',
		showOn: ['astrea'],
		subItems: [
			{
				id: 'func-astrea-processos',
				title: 'Gestão de processos',
				type: 'anchor',
				link: 'processos',
			},
			{
				id: 'func-astrea-tarefas',
				title: 'Gestão de tarefas',
				type: 'anchor',
				link: 'tarefas',
			},
			{
				id: 'func-astrea-equipe',
				title: 'Gestão de equipe',
				type: 'anchor',
				link: 'equipe',
			},
			{
				id: 'func-astrea-financeira',
				title: 'Gestão financeira',
				type: 'anchor',
				link: 'financeira',
			},
			{
				id: 'func-astrea-atendimento',
				title: 'Atendimento ao cliente',
				type: 'anchor',
				link: 'atendimento',
			},
		],
	},
	{
		id: 'nav-item-planos',
		type: 'internal-link',
		title: 'Planos e Preços',
		link: '/astrea/planos-e-precos/',
		showOn: ['astrea'],
	},
	{
		id: 'nav-item-clientes',
		type: 'anchor',
		title: 'Nossos clientes',
		link: 'social-proof',
		showOn: ['themisEA', 'themisDJ'],
	},
	{
		id: 'nav-item-produtos',
		type: 'sublist',
		title: 'Nossos produtos',
		showOn: ['aurum', 'themisEA', 'themisDJ', 'subPage'],
		class: 'd-flex',
		ulClass: 'product_box',
		subItems: [
			{
				id: 'product-astrea',
				product: 'astrea',
				spanText: 'para escritórios',
				// type: 'product-card',
				type: 'product-card-link',
				title: 'Astrea',
				content:
					'Impulsione seus resultados com o melhor software jurídico do mercado.',
				link: '/astrea',
				linkText: 'Conhecer agora',
			},
			{
				id: 'product-themis-dj',
				product: 'themis',
				spanText: 'para departamentos jurídicos',
				type: 'product-card',
				title: 'Themis para Departamentos Jurídicos',
				content:
					'Provisione custos, reduza riscos e tome as melhores decisões para a sua empresa.',
				link: '/themis-para-departamento-juridico/',
				linkText: 'Conhecer agora',
			},
			{
				id: 'product-themis-ea',
				product: 'themis',
				spanText: 'para grandes bancas',
				type: 'product-card',
				title: 'Themis para Grandes Bancas',
				content:
					'Automatize as demandas jurídicas e entregue resultados incríveis para o seu escritório.',
				link: '/themis-para-escritorios-de-advocacia/',
				linkText: 'Conhecer agora',
			},
		],
	},
	{
		id: 'nav-item-sobre',
		type: 'sublist',
		title: 'Sobre a Aurum',
		showOn: ['all'],
		subItems: [
			{
				id: 'nav-item-somos',
				type: 'internal-link',
				title: 'Quem somos',
				link: '/quem-somos/',
			},
			{
				id: 'nav-item-trabalhe-conosco',
				type: 'internal-link',
				title: 'Trabalhe conosco',
				link: '/trabalhe-conosco/',
			},
			{
				id: 'nav-item-summit',
				type: 'link',
				title: 'Aurum Summit',
				link: '/aurum-summit/',
			},
		],
	},
	{
		id: 'nav-item-aprenda',
		type: 'sublist',
		title: 'Aprenda',
		showOn: ['all'],
		subItems: [
			{
				id: 'item-aprenda-1',
				type: 'internal-link',
				title: 'Portal',
				link: '/blog/',
			},
			{
				id: 'item-aprenda-2',
				type: 'link',
				title: 'Materiais gratuitos',
				link: '/blog/materiais/',
			},
			{
				id: 'item-aprenda-3',
				type: 'link',
				title: 'CPC Comentado',
				link: '/blog/novo-cpc-comentado/',
			},
			{
				id: 'item-aprenda-4',
				type: 'link',
				title: 'CPP Comentado',
				link: '/blog/cpp-comentado/',
			},
			{
				id: 'item-aprenda-5',
				type: 'link',
				title: 'CDC Comentado',
				link: '/blog/cdc-comentado/',
			},
			{
				id: 'item-aprenda-6',
				type: 'link',
				title: 'CLT Comentada',
				link: '/blog/cdc-comentado/',
			},
			{
				id: 'item-aprenda-7',
				type: 'link',
				title: 'LGPD Comentada',
				link: '/blog/cdc-comentado/',
			},
			{
				id: 'item-aprenda-8',
				type: 'link',
				title: 'Glossário Jurídico',
				link: '/blog/glossario-juridico/',
			},
			{
				id: 'item-aprenda-9',
				type: 'link',
				title: 'Calculadora de Prazos Processuais',
				link: '/calculadora-de-prazos-processuais/',
			},
		],
	},
	{
		id: 'nav-item-contato',
		type: 'internal-link',
		title: 'Contato',
		link: '/contato/',
		showOn: ['home', 'aurum'],
	},
]
